module.exports = __webpack_public_path__ + "img/bebes_e_criancas.8c427009.svg";